import SurveyPageNotFoundContainer from "./SurveyPageNotFoundContainer";
import defaultSurveyTheme from "@fhc/shared/defaultSurveyTheme.json";

const SurveyNotFound = ({ themeColors = defaultSurveyTheme }) => {
    return (
        <SurveyPageNotFoundContainer themeColors={themeColors}>
            {/* Main Content */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    width: "520px",
                    maxWidth: "100%",
                }}
            >
                <div className="font-semibold text-3xl md:text-5xl leading-[60px] text-white mb-[30px] text-center md:text-justify">
                    Survey Not Found
                </div>
                <div className="text-white md:text-[26px] md:leading-[40px] mb-[30px] text-center md:text-justify text-base font-[500]">
                    We couldn't find this survey, please double check the link or request a new one.
                </div>
            </div>
        </SurveyPageNotFoundContainer>
    );
};

export default SurveyNotFound;
